import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { PageContentWrapper, PageHeader, PageDescription } from '../main/LayoutStyles';
import { ReportList, ReportCard } from './MyReportsStyles';
import { AlertBox, StyledButton } from '../main/CommonStyles';
import { Loader2, AlertTriangle, MessageSquare } from 'lucide-react';
import apiClient from '../services/api';
import { useFeatures } from '../feature/FeatureContext'; // NOWY IMPORT

const MyReportsPage = () => {
    const [reports, setReports] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    const navigate = useNavigate();
    const { features } = useFeatures(); // NOWY IMPORT

    useEffect(() => {
        const fetchReports = async () => {
            setLoading(true);
            try {
                const response = await apiClient.get('/cases/my-cases');
                setReports(response.data);
            } catch (err) {
                setError('Nie udało się pobrać listy Twoich zgłoszeń.');
                console.error(err);
            } finally {
                setLoading(false);
            }
        };
        fetchReports();
    }, []);

    const handleCardClick = (id) => {
        navigate(`/app/report/${id}`);
    };

    if (loading) return <PageContentWrapper><div style={{textAlign: 'center'}}><Loader2 className="icon-spin" /> Ładowanie...</div></PageContentWrapper>;
    if (error) return <PageContentWrapper><AlertBox type="error"><AlertTriangle /> {error}</AlertBox></PageContentWrapper>;

    return (
        <PageContentWrapper className="custom-scrollbar">
            <PageHeader>Moje Zgłoszone Sprawy</PageHeader>
            <PageDescription>Tutaj możesz śledzić status swoich zgłoszeń i dodawać do nich nowe informacje.</PageDescription>

            <ReportList>
                {reports.length > 0 ? reports.map(report => (
                    <ReportCard key={report.id} status={report.status} onClick={() => handleCardClick(report.id)}>
                        <div className="card-header">
                            <h3>{report.title}</h3>
                            <span className="status-badge">{report.status || 'NOWE'}</span>
                        </div>
                        <div className="card-footer">
                            Utworzono: {new Date(report.createdAt).toLocaleString('pl-PL')} | Ostatnia aktualizacja: {new Date(report.updatedAt).toLocaleString('pl-PL')}
                        </div>
                    </ReportCard>
                )) : (
                    <div style={{textAlign: 'center', padding: '2rem', border: '2px dashed #e2e8f0', borderRadius: '0.75rem', marginTop: '1rem'}}>
                        <MessageSquare size={48} style={{color: '#cbd5e1'}} />
                        <p style={{marginTop: '1rem', color: '#64748b', fontWeight: 500}}>Nie masz jeszcze żadnych zgłoszonych spraw.</p>
                        {/* ZMIANA: Przycisk widoczny tylko, jeśli funkcja jest włączona */}
                        {features.REPORTING && (
                            <StyledButton onClick={() => navigate('/app/report-form')} style={{marginTop: '1rem'}}>
                                Zgłoś nową sprawę
                            </StyledButton>
                        )}
                    </div>
                )}
            </ReportList>
        </PageContentWrapper>
    );
};

export default MyReportsPage;